import type { CSSProperties, FC } from 'react'
import { cx } from '@/common/utils/className'
import type { CurzonGridRow } from './grid.types'
import { GridElementsComponent } from './GridElementsComponent'
import { TabLayout } from './tabLayout/TabLayout'

export const GridRowComponent: FC<CurzonGridRow> = props => {
    const { background, fullWidth, wideBackground } = props?.config ?? {}
    const bgClass = `bg-${background?.label ?? 'white'}` // also used by carousel component to decide nav-buttons bg-color

    if (props.name === 'tabLayout') {
        return <TabLayout {...props} />
    }

    const rowStyles: CSSProperties = {
        gridTemplateColumns: props.columns.map(c => `calc((100% / 12) * ${c.size})`).join(' '),
        backgroundColor: background?.color ? `#${background.color}` : undefined,
    }

    if (!props?.columns) return null

    const clsNames = cx('grid-row', { gridFullWidth: !!fullWidth, wideBg: !!wideBackground })
    return (
        <div className={`${clsNames} ${bgClass}`} style={rowStyles}>
            {props.columns.map((column, index) => (
                <div className="grid-column" key={'grid-column-' + index}>
                    <div className="grid-column__content">
                        <GridElementsComponent {...column} additionalData={props.additionalData} />
                    </div>
                </div>
            ))}
        </div>
    )
}
